<template>
  <v-layout column>
    <kernel-input-message-info-view
      :loading-error="loadingError"
      :input-message="inputMessage"
      :loading="isLoading"
    />

    <vbt-content-box
      :loading="isLoading"
      :loading-error="loadingError"
      title="Request & Response"
    >
      <v-layout>
        <v-flex
          class="pr-2"
          lg6
        >
          <vbt-code
            :value="requestCode"
            max-height="400px"
            readonly
          />
        </v-flex>
        <v-flex
          class="pl-2"
          lg6
        >
          <vbt-code
            :value="responseCode"
            max-height="400px"
            readonly
          />
        </v-flex>
      </v-layout>
    </vbt-content-box>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { useDataLoading } from '@mixins/factories';

import KernelInputMessageInfoView from '../_components/KernelInputMessageInfoView.vue';

import { namespace as InputMessagesNamespace, ActionTypes as InputMessagesActionTypes } from '../store.types';

const dataLoadingOptions = {
  getterName: InputMessagesActionTypes.GET_INPUT_MESSAGE,
  parameterize: true,
  searchable: false,
  paged: false,
};

const formatCodeFragment = (code) => {
  try {
    return JSON.stringify(JSON.parse(code || ''), null, '\t');
  } catch (e) {
    return '';
  }
};

export default {
  name: 'KernelInputMessage',
  components: {
    KernelInputMessageInfoView,
  },
  mixins: [
    useDataLoading(dataLoadingOptions),
  ],
  computed: {
    ...mapState(InputMessagesNamespace, {
      inputMessage: ({ inputMessage }) => inputMessage,
      requestCode: ({ inputMessage: { request } }) => formatCodeFragment(request),
      responseCode: ({ inputMessage: { response } }) => formatCodeFragment(response),
    }),
  },
  methods: {
    ...mapActions(InputMessagesNamespace, [InputMessagesActionTypes.GET_INPUT_MESSAGE]),
  },
};
</script>
